import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Card,
  CardContent,
  FormField,
  Input,
  Textarea,
} from '@cartcloser/ui';
import { Section } from '@cartcloser/ui/marketing';
import { CONTACT_EMAIL } from '../site.js';

export const Route = createFileRoute('/contact')({
  component: ContactPage,
});

function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [store, setStore] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    const subject = `CartCloser enquiry — ${name || 'website'}`;
    const body = [
      `Name: ${name}`,
      `Email: ${email}`,
      store ? `Store: ${store}` : '',
      '',
      message,
    ]
      .filter(Boolean)
      .join('\n');
    // No backend yet: open the visitor's mail client addressed to Tim.
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(body)}`;
    setSent(true);
  }

  return (
    <Section
      eyebrow="Contact"
      title="Get in touch"
      subtitle="Tell me about your store and I’ll show you CartCloser running on your own catalogue."
    >
      <Card className="mx-auto max-w-xl">
        <CardContent className="p-6">
          {sent ? (
            <Alert variant="success">
              <AlertTitle>Thanks — your email is ready to send</AlertTitle>
              <AlertDescription>
                Your mail app should have opened with the message. If it didn’t, email{' '}
                <a className="font-medium text-primary hover:underline" href={`mailto:${CONTACT_EMAIL}`}>
                  {CONTACT_EMAIL}
                </a>
                .
              </AlertDescription>
            </Alert>
          ) : (
            <form className="space-y-4" onSubmit={onSubmit}>
              <FormField label="Name" required>
                {({ id }) => <Input id={id} value={name} onChange={(e) => setName(e.target.value)} required />}
              </FormField>
              <FormField label="Email" required>
                {({ id }) => (
                  <Input
                    id={id}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                )}
              </FormField>
              <FormField label="Store URL">
                {({ id }) => (
                  <Input
                    id={id}
                    value={store}
                    onChange={(e) => setStore(e.target.value)}
                    placeholder="https://yourstore.com"
                  />
                )}
              </FormField>
              <FormField label="What do you sell?">
                {({ id }) => (
                  <Textarea id={id} rows={4} value={message} onChange={(e) => setMessage(e.target.value)} />
                )}
              </FormField>
              <Button type="submit" className="w-full">
                Send
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </Section>
  );
}
